import { Action, createReducer, on } from '@ngrx/store';
import * as ReplaceProductServiceWizardActionsV26 from './actions';
import { State, initialState } from './state';

export const replaceProductServiceWizardFeatureKey = 'replaceProductServiceWizardV26';

const replaceProductServiceWizardReducer = createReducer(
  initialState,

  on(ReplaceProductServiceWizardActionsV26.selectInitStep, (state, { initStep }) => ({
    ...state,
    initStep,
    dueDatesStep: { activationDate: null },
  })),
  on(ReplaceProductServiceWizardActionsV26.selectDueDatesStep, (state, { dueDatesStep }) => ({
    ...state,
    dueDatesStep,
  })),
  on(ReplaceProductServiceWizardActionsV26.selectReplacementStep, (state, { replacementStep }) => ({
    ...state,
    replacementStep,
  })),
  on(ReplaceProductServiceWizardActionsV26.selectBillingStep, (state, { billingStep }) => ({
    ...state,
    billingStep,
  })),
  on(ReplaceProductServiceWizardActionsV26.exitReplaceProductServiceWizard, (state) => ({
    ...state,
    initStep: null,
    dueDatesStep: null,
    replacementStep: null,
    billingStep: null,
    errorMessage: null,
    request: null,
    response: null,
  })),
  on(ReplaceProductServiceWizardActionsV26.destroyWizard, (state) => ({
    ...state,
    initStep: null,
    dueDatesStep: null,
    replacementStep: null,
    billingStep: null,
    errorMessage: null,
    request: null,
    response: null,
  })),
  on(ReplaceProductServiceWizardActionsV26.createNewReplaceProductService, (state, { request }) => ({
    ...state,
    request,
  })),
  on(ReplaceProductServiceWizardActionsV26.createNewReplaceProductServiceSuccess, (state, { response }) => ({
    ...state,
    response,
  })),
  on(ReplaceProductServiceWizardActionsV26.createNewReplaceProductServiceFail, (state, { errorMessage }) => ({
    ...state,
    errorMessage,
  })),
);

export function reducer(state: State | undefined, action: Action) {
  return replaceProductServiceWizardReducer(state, action);
}
